module.exports = __webpack_public_path__ + "img/search.8d38c7e0.svg";